import { NgModule }     from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoadingStatusPipe }            from './loading-status.pipe';
import { DisableWhileLoadingDirective } from './disable-while-loading.directive';


@NgModule({
  declarations: [
    LoadingStatusPipe,
    DisableWhileLoadingDirective,
  ],
  imports:      [
    CommonModule
  ],
  exports:      [
    LoadingStatusPipe,
    DisableWhileLoadingDirective,
  ]
})
export class LoadingModule {}
